export default __webpack_public_path__ + "static/media/button-group.50076128.svg";